
import { computed, defineComponent, ref } from "vue";

export default defineComponent({
    name: "AppTooltip",
    props: {
        content: {
            type: String,
            required: true
        },
        position: {
            type: String,
            default: "top",
            validator: (value: string) =>
                ["top", "bottom", "left", "right"].includes(value)
        }
    },
    setup(props) {
        const showTooltip = ref(false);

        const tooltipClasses = computed(() => {
            switch (props.position) {
                case "top":
                    return "bottom-full left-1/2 transform -translate-x-1/2 mb-2 break-words";
                case "bottom":
                    return "top-full left-1/2 transform -translate-x-1/2 mt-2 break-words";
                case "left":
                    return "right-full top-1/2 transform -translate-y-1/2 mr-2 break-words";
                case "right":
                    return "left-full top-1/2 transform -translate-y-1/2 ml-2 break-words";
                default:
                    return "bottom-full left-1/2 transform -translate-x-1/2 mb-2 break-words";
            }
        });

        const arrowClasses = computed(() => {
            switch (props.position) {
                case "top":
                    return "top-full left-1/2 transform -translate-x-1/2 -mt-1";
                case "bottom":
                    return "bottom-full left-1/2 transform -translate-x-1/2 -mb-1";
                case "left":
                    return "left-full top-1/2 transform -translate-y-1/2 -ml-1";
                case "right":
                    return "right-full top-1/2 transform -translate-y-1/2 -mr-1";
                default:
                    return "top-full left-1/2 transform -translate-x-1/2 -mt-1";
            }
        });

        return {
            showTooltip,
            tooltipClasses,
            arrowClasses
        };
    }
});
